module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      comment: true, deleting: _vm.submittingDelete
    }
  }, [_c('div', {
    staticClass: "comment-actions dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [(_vm.canEdit) ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleEditForm
    }
  }, [_vm._v("\n                    Edit\n                ")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleReplyForm
    }
  }, [_vm._v("\n                    Reply\n                ")])]), _vm._v(" "), (_vm.canDelete) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('li', [_c('button', {
    staticClass: "clear-button danger",
    attrs: {
      "type": "button",
      "disabled": _vm.submittingDelete
    },
    on: {
      "click": _vm.emitDelete
    }
  }, [_vm._v("\n                    Delete\n                ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "comment-author"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          author: _vm.comment.author.id
        }
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.comment.author.name) + "\n        ")])], 1), _vm._v(" "), (_vm.editFormVisible) ? _c('gallery-comment-form', {
    ref: "editForm",
    attrs: {
      "placeholder": "Edit...",
      "submitText": "Save",
      "cancelable": true,
      "initialText": _vm.comment.text
    },
    on: {
      "cancel": _vm.toggleEditForm,
      "submit": _vm.emitEdit,
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      }
    }
  }) : _c('div', {
    staticClass: "comment-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.escapeHtml(_vm.comment.text)))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-like-actions"
  }, [(!_vm.hasLikedComment()) ? _c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittingLike
    },
    on: {
      "click": _vm.emitLike
    }
  }, [_vm._v("\n            Like\n        ")]) : _c('button', {
    staticClass: "clear-button",
    attrs: {
      "type": "button",
      "disabled": _vm.submittingLike
    },
    on: {
      "click": _vm.emitUnlike
    }
  }, [_vm._v("\n            Unlike\n        ")]), _vm._v(" "), (_vm.comment.likes.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.formatLikesText(_vm.comment.likes.length)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "reply-section"
  }, [_c('ol', _vm._l((_vm.comment.replies), function(reply) {
    return _c('li', [_c('gallery-comment', {
      staticClass: "comment",
      attrs: {
        "comment": reply
      },
      on: {
        "like": _vm.forwardLike,
        "unlike": _vm.forwardUnlike,
        "edit": _vm.forwardEdit,
        "reply": _vm.forwardReply,
        "delete": _vm.forwardDelete,
        "focus": function($event) {
          _vm.$emit('focus')
        },
        "blur": function($event) {
          _vm.$emit('blur')
        }
      }
    })], 1)
  })), _vm._v(" "), (_vm.replyFormVisible) ? _c('gallery-comment-form', {
    ref: "replyForm",
    attrs: {
      "placeholder": "Reply...",
      "cancelable": true
    },
    on: {
      "cancel": _vm.toggleReplyForm,
      "submit": _vm.emitReply,
      "focus": function($event) {
        _vm.$emit('focus')
      },
      "blur": function($event) {
        _vm.$emit('blur')
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ccf2137!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GalleryComment.vue
// module id = 2089
// module chunks = 2